import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { FinancialyearService } from '../../main-layout/financialyear/financialyear.service';
import { BaseClass } from '../../utility/baseClass';

@Component({
  selector: 'app-financialyearmodal',
  templateUrl: './financialyearmodal.component.html',
  styleUrls: ['./financialyearmodal.component.css']
})
export class FinancialyearmodalComponent extends BaseClass implements OnInit {
saveTitle = 'Add'
  isEdit: boolean = false;
  newyearupdate: any;
  yearDetails: any = {};
  finYearForm: FormGroup;
  CSRFToken = "";
  finyrid = null;
  newyear: any;
  onlyView: any; 
  hasLimitedAccess = "N";
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  constructor(
    public override  injector: Injector,
    private FinancialyearService: FinancialyearService,
    private formBuilder: FormBuilder,
    public router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
     private utilityservice:Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;

    this.gettoken();
    if (dataFromParent?.title == 'Modify Financial Year') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.yearDetails = dataFromParent.datas
      this.hasLimitedAccess = dataFromParent.hasLimitedAccess;
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData(); 
  }
 
  patchValueForms(data) {
    this.finyrid = data[0].finyrid;
    this.finYearForm.patchValue({ 'finyrid': data[0].finyrid });
    this.finYearForm.patchValue({ 'finyr': data[0].finyr });
    this.finYearForm.patchValue({ 'activeflag': data[0].activeflag });
  }

  getData() {
    if (this.yearDetails.length !== undefined) {
      this.patchValueForms(this.yearDetails)
    }
  }


  formInitiliaze() {

    this.finYearForm = this.formBuilder.group({
      finyr: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        //Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      activeflag: ['Y']
    })
  }
  gettoken() { 
    this.CSRFToken='';
             this.utilityservice.getCSRFtoken().subscribe(res=>{
             this.CSRFToken=res.csrf;
            },error=>{
              Swal.fire(error.error.message,'','error');
            });
  }

  public validation_message = {
    finyr: [
      { type: 'required', message: 'Financial Year is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter Financial Year' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  }
  addYear() {
    const payload = {
      finyr: this.finYearForm.get('finyr').value,
      activeflag: "Y",
      csrftoken: this.CSRFToken,
    }; 
    if (this.saveTitle === 'Modify') {
      this.modifyYear(payload);
    } else {
      if (this.finYearForm.invalid) {
        this.validateAllFormFields(this.finYearForm);
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`,
        }).then((value) => {
          if (value.isConfirmed) {
            this.FinancialyearService.addYear(payload).subscribe({
              next: (data) => {
                this.newyear = data;
                if (this.newyear.response === 'exists') {
                  Swal.fire("Financial Year already exists!", "", "error").then(() => {
                    //this.ref.close();
                  });
                } else {
                  Swal.fire("Financial Year added successfully!", "", "success").then(() => {
                    this.ref.close();
                  });
                }
              },
              error: (error) => {
                if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
                Swal.fire({
                  title: "Error Saving Financial Year",
                  text: error.error.message || "An unexpected error occurred.",
                  icon: "error",
                });}
              },
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
            this.ref.close();
          }
        });
      }
    }
  }

  modifyYear(data: any) {

    data["finyrid"] = this.finyrid;
    data["activeflag"] = this.finYearForm.get('activeflag').value;
    if (this.finYearForm.invalid) {
      this.validateAllFormFields(this.finYearForm);
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`,
      }).then((value) => {
        if (value.isConfirmed) {
          this.FinancialyearService.modifyYear(data).subscribe({
            next: (response) => {
              this.newyearupdate = response;
              if (this.newyearupdate.response === 'exists') {
                Swal.fire("Financial Year already exists!", "", "error").then(() => {
                  //this.ref.close();
                });
              } else {
                Swal.fire("Financial Year modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({
                title: "Error Saving Financial Year",
                text: error.error.message || "An unexpected error occurred.",
                icon: "error",
              });}
            },
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }
}
